<template lang="pug">
.open-system-container(v-if="show", @touchmove.prevent)
  .open-system-block
    .open-stytem-close(@click="closeModal")
      img(src="https://m.hellobike.com/resource/helloyun/08345/bMneu_x9N6.png")
    .open-system-title 用户服务协议确认
    .open-system-word 为了保障你的合法权益，请认真阅读并同意
    .open-system-word
      span.orange-word(@click="goMember") 《哈啰骑行卡服务协议》
      span 和
      span.orange-word(@click="goRenewal") 《自动续费协议》
    .open-read-btn(@click="readOk") 同意协议并支付
  .shadow()
</template>

<script>
import { commonGoLink } from '@/utils';
import { PROTOCOL_URL } from '../../common/const';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    goRenewal() {
      commonGoLink(PROTOCOL_URL.RENEWAL, { isRuleLink: true });
    },
    goMember() {
      commonGoLink(PROTOCOL_URL.MEMBER, { isRuleLink: true });
    },
    readOk() {
      this.$emit('readOk');
      this.$emit('close');
    },
  },

};
</script>
<style lang="less" scoped>
.open-system-container {
  position: fixed;
  bottom: 0;
  z-index: 300;
  width: 100%;

  .open-system-block {
    width: 100%;
    height: 2.45rem;
    background: #fff;
    border-radius: 0.12rem 0.12rem 0 0;
    z-index: 101;
    position: relative;
    padding-top: 0.2rem;
    // margin: 3rem auto 0 auto;

    .open-stytem-close {
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;

      img {
        width: 0.16rem;
        height: 0.16rem;
        display: block;
      }
    }

    .open-system-title {
      text-align: center;
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
      margin-bottom: 0.24rem;
    }

    .open-system-word {
      text-align: center;
      font-size: 0.14rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #242729;
      line-height: 0.2rem;

      .orange-word {
        color: #08f;
      }
    }

    .open-read-btn {
      margin: 0.2rem auto 0 auto;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      width: 3.35rem;
      height: 0.48rem;
      line-height: 0.48rem;
      font-weight: 600;
      color: #fff;
      background:
        linear-gradient(
          106.2deg,
          #ff41b9 -29.76%,
          #ff3c70 20.55%,
          #ff4c31 77.01%,
          #ffba43 109.99%
        );
      border-radius: 0.48rem;
      text-align: center;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
